export default __webpack_public_path__ + "static/media/recommendation.37147b88.svg";